import { getChannelSubtitles } from '../utils/get-channel-subtitles';

import { useCurrentChannelStream } from './use-current-channel-stream';

export const useSubtitles = (contentId: string) => {
    const stream = useCurrentChannelStream(contentId);

    return getChannelSubtitles(stream);
};
